import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { array, string, object } from "prop-types";
import { differenceInHours } from "date-fns";

import CustomStoryCard10 from "../../molecules/CustomStoryCard10";
import DfpAd from "../../dfp-ad";
import More from "../../atoms/More";
import { pushEngage } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";

import "./notificationStories.m.css";

const NotificationStories = ({ stories, pushEngageApiKey, publisherAttributes }) => {
  const [notificationStories, setNotificationStories] = useState([]);
  const [currentNotificationsCount, setCurrentNotificationsCount] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    setIsDesktop(global.deviceWidth > 1263);
  }, []);

  useEffect(() => {
    const latestNotifications = stories.filter(
      item => differenceInHours(new Date(), new Date(item.created_time + " GMT".toLocaleString())) <= 48
    );
    setNotificationStories(latestNotifications);
    setCurrentNotificationsCount(latestNotifications.length);
  }, [stories, notificationStories]);

  const storiesDom = notificationStories.map((story, index) => (
    <React.Fragment key={index}>
      {index !== 0 && index % 4 === 0 && (
        <div styleName="ad-wrapper">
          <div styleName="ad-slot">
            <DfpAd adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"} />
          </div>
        </div>
      )}
      <CustomStoryCard10 story={story} />
    </React.Fragment>
  ));

  const fetchNotifications = () => {
    const offset = notificationStories.length;
    const limit = 8;
    pushEngage(offset, limit, pushEngageApiKey).then(resp => {
      setCurrentNotificationsCount(resp ? resp.length : 0);
      setNotificationStories([...notificationStories, ...(resp || [])]);
    });
  };

  return (
    <React.Fragment>
      <div styleName="wrapper">
        {isDesktop && <div />}
        <div>
          {storiesDom}
          {notificationStories.length >= 8 && currentNotificationsCount > 0 && (
            <div styleName={`load-more-view ${publisherAttributes.lang === "en" ? "en-load-more-view" : ""}`}>
              <More type="load-more" text={staticTexts(publisherAttributes.lang).more} onClick={fetchNotifications} />
            </div>
          )}
        </div>
        <div>
          <div styleName="side-ad">
            <DfpAd adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

NotificationStories.propTypes = {
  stories: array,
  pushEngageApiKey: string,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export default connect(mapStateToProps, null)(NotificationStories);
